import { computed } from 'vue';
import { MaybeRef } from '@vueuse/core';

import useLiveVirtualPortfolioQuery from './useLiveVirtualPortfolioQuery';
import { TreeMapDataType } from '../usePortfolioMap';

export default function useVirtualPortfolioMap(
  {
    listen,
    immediate,
  }: {
    listen?: boolean;
    immediate: MaybeRef<boolean>;
  } = { listen: true, immediate: false }
) {
  const {
    symbols,
    isLoadingVirtualPortfolioSymbols,
    isSuccessVirtualPortfolioSymbols,
    getVirtualPortfolio,
    isErrorVirtualPortfolioSymbols,
  } = useLiveVirtualPortfolioQuery({ listen, immediate });

  const virtualPortfolioMap = computed<TreeMapDataType>(() => ({
    name: '',
    children: symbols.value.map((symbol) => ({
      percent: symbol.returnValuePercentage?.toFixed(2),
      value: symbol.value,
      name: symbol.instrumentName,
      isin: symbol.instrumentIsin,
    })),
  }));

  return {
    virtualPortfolioMap,
    isLoadingVirtualPortfolioSymbols,
    isErrorVirtualPortfolioSymbols,
    getVirtualPortfolio,
    isSuccessVirtualPortfolioSymbols,
  };
}
